module.exports = __webpack_public_path__ + "img/addMorePlusArrow.f88b46f1.svg";